import { authService } from '../services/authService'
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { notifyError, notifySuccess } from "../utils/notifications";
import { UserContext } from "../utils/UserContext";

const Login = ({ setIsLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showLoginPassword, setShowLoginPassword] = useState(false);
    const [isRegisterScreen, setIsRegisterScreen] = useState(false);
    const [registerData, setRegisterData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [showRegisterPassword, setShowRegisterPassword] = useState(false);
    const [showRegisterConfirmPassword, setShowRegisterConfirmPassword] = useState(false);
    const { setUser } = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const mode = params.get('mode');
        setIsRegisterScreen(mode === 'register');
    }, [location.search]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRegisterData({ ...registerData, [name]: value });
    };

    const loginOnClick = async () => {
        try {
            const data = await authService.login(email, password);

            // Guardar el usuario en el contexto
            setUser(data.user);

            // Establecer el estado de login y redirigir
            setIsLogin(true);
            navigate('/talleres');
            notifySuccess(`Inicio de sesión exitoso. Bienvenido, ${data.user.username}!`);
        } catch (error) {
            console.error('Error en login:', error);
            notifyError("Error al iniciar sesión. Verifica tus credenciales.");
        }
    };

    const handleGoogleLogin = async () => {
        try {
            const authorizeUrl = await authService.getGoogleAuthUrl();

            // Redirigir al usuario a Google
            window.location.href = authorizeUrl;
        } catch (error) {
            console.error('Error al obtener URL de Google:', error);
            notifyError("Error al iniciar sesión con Google");
        }
    };

    const registerOnClick = async () => {
        const { email, firstName, lastName, password, confirmPassword } = registerData;

        // Validar que las contraseñas coincidan
        if (password !== confirmPassword) {
            notifyError("Las contraseñas no coinciden.");
            return;
        }

        // Crear el payload para la API
        const payload = {
            email: email,
            username: `${firstName} ${lastName}`,
            password: btoa(password),
            role: "owner"
        };

        try {
            const data = await authService.register(payload);

            // Después de registrar exitosamente, se inicia sesión automáticamente
            // Setear el objeto user completo (no solo username string)
            setUser(data.user);
            setIsLogin(true);
            navigate('/talleres');
            notifySuccess(`Usuario registrado exiosamente. Bienvenido, ${firstName}!`);
        } catch (error) {
            console.error('Error en registro:', error);
            notifyError("Ocurrió un error al intentar registrar el usuario.");
        }
    };

    const GoogleAuthButton = ({ label }) => (
        <button
            type="button"
            className="auth-provider-btn auth-provider-btn-google"
            onClick={handleGoogleLogin}
        >
            <img 
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                alt="Google"
                className="auth-provider-icon"
            />
            {label}
        </button>
    ); 

    return (
        <div className="loginPage">
            <div className="formLogin">
                <section>
                    <h1>TAT MANAGER</h1>
                    {isRegisterScreen ? (
                        <form onSubmit={(e) => e.preventDefault()}>
                            <input
                                name="email"
                                type="email"
                                autoComplete="email"
                                placeholder="Correo electrónico"
                                value={registerData.email}
                                onChange={handleInputChange}
                            />
                            <div className="name-row">
                                <input
                                    name="firstName"
                                    type="text"
                                    placeholder="Nombre"
                                    style={{ marginRight: "10px" }}
                                    value={registerData.firstName}
                                    onChange={handleInputChange}
                                />
                                <input
                                    name="lastName"
                                    type="text"
                                    placeholder="Apellido"
                                    value={registerData.lastName}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="password-field">
                                <input
                                    name="password"
                                    type={showRegisterPassword ? "text" : "password"}
                                    autoComplete="new-password"
                                    placeholder="Contraseña"
                                    value={registerData.password}
                                    onChange={handleInputChange}
                                />
                                <span
                                    className="password-toggle"
                                    onClick={() => setShowRegisterPassword(prev => !prev)}
                                    aria-label={showRegisterPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                >
                                    {showRegisterPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <div className="password-field">
                                <input
                                    name="confirmPassword"
                                    type={showRegisterConfirmPassword ? "text" : "password"}
                                    autoComplete="new-password"
                                    placeholder="Confirmar Contraseña"
                                    value={registerData.confirmPassword}
                                    onChange={handleInputChange}
                                />
                                <span
                                    className="password-toggle"
                                    onClick={() => setShowRegisterConfirmPassword(prev => !prev)}
                                    aria-label={showRegisterConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                >
                                    {showRegisterConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <button type="submit" onClick={registerOnClick}>
                                Crear Cuenta
                            </button>
                            <div className="auth-divider">
                                <span>o</span>
                            </div>
                            <GoogleAuthButton label="Regístrate con Google" />
                            <footer>
                                <button
                                    type="button"
                                    className="link-button"
                                    onClick={() => setIsRegisterScreen(false)}
                                >
                                    ¿Ya tienes una cuenta? Inicia sesión.
                                </button>
                            </footer>
                        </form>
                    ) : (
                        <form onSubmit={(e) => e.preventDefault()}>
                            <input
                                name="email"
                                type="email"
                                autoComplete="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Correo eléctronico"
                            />
                            <div className="password-field">
                                <input
                                    name="password"
                                    type={showLoginPassword ? "text" : "password"}
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Contraseña"
                                />
                                <span
                                    className="password-toggle"
                                    onClick={() => setShowLoginPassword(prev => !prev)}
                                    aria-label={showLoginPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                >
                                    {showLoginPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <div className="form-footer">
                            </div>
                            <button type="submit" onClick={loginOnClick}>
                                Entrar
                            </button>

                            <div className="auth-divider">
                                <span>o</span>
                            </div>
                            <GoogleAuthButton label="Continuar con Google" />

                            <footer>
                                <button
                                    type="button"
                                    className="link-button"
                                    onClick={() => setIsRegisterScreen(true)}
                                >
                                    ¿No tienes una cuenta? Regístrate.
                                </button>
                            </footer>
                        </form>
                    )}
                </section>
            </div>
        </div>
    );
};

export default Login;
